import { createContext } from "react";

const HelpDeskContext = createContext();

export default HelpDeskContext;
